import styled from 'styled-components';

const MergeModalStyled = styled.div`
  background: #ffffff;
  .merge-btn-content {
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.87);
    line-height: 21px;
    .content-merge {
      color: #d10000;
    }
  }
  .btn-wrap {
    float: right;
    margin-top: 45px;
    button {
      width: 51px;
    }
  }
`;

export default MergeModalStyled;
